import Vue from 'vue'
import Router from 'vue-router'
import Users from '@/components/Users'
import Statistics from '@/components/Statistics'
import Settings from '@/components/Settings'
import Cron from '@/components/Cron'
import Emailsenders from '@/components/EmailSenders'
import EmailSettings from '@/components/EmailSettings'
import Professions from '../components/Professions.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/users/',
      name: 'Users',
      props: true,
      component: Users
    },
    {
      path: '/professions',
      name: 'Professions',
      component: Professions
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },  
    {
      path:'/cronsettings',
      name: 'Cron',
      component:Cron
    },
    {
      path: '/emailsenders',
      name: 'Emailsenders',
      component: Emailsenders
    }, 
    {
      path:'/emailsettings',
      name: 'EmailSettings',
      component:EmailSettings
    },   
    {
      path: '/statistics/:id',
      name: 'Statistics',
      component: Statistics
    },
  ]
})